import React, { useState } from "react";
import { BiDotsHorizontal } from "react-icons/bi";

function TextWithSeeMore({ text, maxLength, background }) {
  const [isTruncated, setIsTruncated] = useState(true);

  const toggleTruncate = () => {
    setIsTruncated(!isTruncated);
  };

  // Split text into paragraphs by looking for line breaks or multiple spaces
  const formatTextIntoParagraphs = (text) => {
    if (!text) return [];
    // Split by double line breaks or multiple spaces indicating paragraph breaks
    return text.split(/\n{2,}|\r\n{2,}|(?:\s{2,})/g).filter(para => para.trim().length > 0);
  };

  const paragraphs = formatTextIntoParagraphs(text);

  return (
    <div>
      {isTruncated ? (
        <div>
          {text?.length > maxLength ? (
            // Show truncated text
            <div>
              {text.slice(0, maxLength)}
              <button
                onClick={toggleTruncate}
                style={{
                  border: "none",
                  marginLeft: "0.2rem",
                  fontSize: "1rem",
                  background: `${background}`,
                }}
              >
                <BiDotsHorizontal
                  style={{
                    border: "none",
                    color: "gray",
                    fontSize: "1rem",
                    marginTop: "0.24rem",
                  }}
                />
              </button>
            </div>
          ) : (
            // If text is short, show the paragraphs
            paragraphs.map((paragraph, index) => (
              <p key={index} style={{ marginBottom: "0.5rem" }}>
                {paragraph}
              </p>
            ))
          )}
        </div>
      ) : (
        <div>
          {/* Show full text with paragraphs */}
          {paragraphs.map((paragraph, index) => (
            <p key={index} style={{ marginBottom: "0.5rem" }}>
              {paragraph}
            </p>
          ))}
          <button
            onClick={toggleTruncate}
            style={{
              border: "none",
              marginLeft: "0.2rem",
              background: `${background}`,
            }}
          >
            See Less
          </button>
        </div>
      )}
    </div>
  );
}

export default TextWithSeeMore;
